(() => {
  const init = root => {
    root.querySelectorAll('[data-cft-announcements]').forEach(rail => {
      if (rail.dataset.ready) return;
      rail.dataset.ready = 'true';
      const messages = [...rail.querySelectorAll('[data-announcement]')];
      if (messages.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      let index = 0;
      const timer = setInterval(() => {
        if (!rail.isConnected) { clearInterval(timer); return; }
        if (document.hidden) return;
        messages[index].hidden = true;
        index = (index + 1) % messages.length;
        messages[index].hidden = false;
      }, 5000);
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
